import { render, staticRenderFns } from "./AxRoadPage.vue?vue&type=template&id=62dc5e16&"
import script from "./AxRoadPage.vue?vue&type=script&lang=js&"
export * from "./AxRoadPage.vue?vue&type=script&lang=js&"
import style0 from "./AxRoadPage.vue?vue&type=style&index=0&id=62dc5e16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports